import { defineModule, } from 'direct-vuex';
import { isDate, isObject, } from '~/utils/models/isObject';
import { initialiseStoreValue, } from '~/utils/store';

export interface CustomerPaymentDetails {
	accountBalance: number;
	amountDue: number;
	currentDueDate: Date;
	paymentMethod: string;
}

export interface PayBillState {
	currentStep: 1 | 2 | null;
	paymentDetails: CustomerPaymentDetails | null;
}

const PaymentDetailsStorageKey = 'payBill.paymentDetails';

function isPaymentDetails(input: unknown): input is CustomerPaymentDetails {
	return (
		true &&
		isObject(input) &&
		typeof input.accountBalance === 'number' &&
		typeof input.amountDue === 'number' &&
		isDate(input.currentDueDate) &&
		true
	);
}

function initialisePaymentDetails() {
	return initialiseStoreValue(
		PaymentDetailsStorageKey,
		isPaymentDetails,
		() => null,
		(userInput) => {
			// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
			userInput.currentDueDate = new Date(userInput.currentDueDate);
			// eslint-disable-next-line @typescript-eslint/no-unsafe-return
			return userInput;
		},
	);
}

export default defineModule({
	namespaced: true as const,
	state: {
		currentStep: 1,
		paymentDetails: initialisePaymentDetails(),
	} as PayBillState,
	getters: {
		hasExistingPaymentDetails(state) {
			return state.paymentDetails !== null;
		},
	},
	mutations: {
		setStep(state, step: PayBillState['currentStep']) {
			state.currentStep = step;
		},
		updatePaymentDetails(state, paymentDetails: CustomerPaymentDetails) {
			sessionStorage.setItem(PaymentDetailsStorageKey, JSON.stringify(paymentDetails));
			state.paymentDetails = paymentDetails;
		},
		reset(state) {
			sessionStorage.removeItem(PaymentDetailsStorageKey);
			state.paymentDetails = null;
		},
	},
});
